// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__pR6VS","modalFooterButton":"ModalNotes_modalFooterButton__2JWB2"};